<template>
  <div class="container">
    <div class="header">
      <div class="logo-container">
        <img src="@/assets/logo.svg" alt="Scanada Logo" class="logo" />
      </div>

      <div class="message_container">
        <h2>Is it Canadian?</h2>
        <p>Helping Canadians make informed consumer decisions.</p>
      </div>
    </div>

    <div class="buttons">
      <!-- Router-link used for navigation -->
      <router-link to="/scan" class="primary-btn">Start Scanning</router-link>
      <p style="font-size: 10px;">*currently only working with Food UPC's</p>
    </div>

    <!-- Row for Disclaimer and Add Your Company buttons -->
    <div class="bottom-buttons-row">
      <router-link to="/about" class="bottom-btn">Info / Disclaimer</router-link>
      <router-link to="/company-form" class="bottom-btn">Add Your Product</router-link>
    </div>

    <div v-if="donations" class="footer">
      <a href="http://buymeacoffee.com/scanada" target="_blank" class="buy-coffee">Buy Us a Coffee</a>
      <img src="@/assets/coffee-cup.svg" alt="Buy Us a Coffee" class="icon" />
    </div>
  </div>
</template>

<script>

export default {
  methods: {
    addToHomeScreen() {
      alert("Feature to add to the home screen coming soon!");
    },
  },
  computed: {
    donations() {
      return process.env.VUE_APP_ENABLE_DONATIONS === "true"; 
    }
  }
};
</script>

<style scoped>
.container {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100vh;
  padding: 40px;
  background: var(--red);
  color: var(--white);
  overflow: hidden;
}

.container::before {
  content: '';
  position: absolute;
  top: 40%;
  left: 50%;
  width: 150%;
  height: 150%;
  background-image: url('@/assets/leaf_red.svg');
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: contain;
  transform: translate(-50%, -50%);
  opacity: 0.25;
  z-index: 0;
}

.message_container {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 0px;
}

.header {
  margin-bottom: 40px;
  z-index: 1;
}

.logo {
  width: 250px;
  margin-bottom: 10px;
}

.logo-container {
  position: relative;
  display: inline-block;
}

.logo {
  width: 250px;
  margin-bottom: 10px;
}

.tm-symbol {
  position: absolute;
  top: 0%;
  right: -15px;
  font-size: 12px;
  font-weight: light;
  color: var(--white);
}


.icon {
  width: 24px;
}

h2 {
  font-size: 22px;
  margin: 0px;
}

p {
  font-size: 14px;
  margin: 0px;
}

.buttons {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 200px;
  z-index: 1;
}

.primary-btn {
  width: 100%;
  padding: 12px;
  font-size: 18px;
  font-weight: bold;
  border: none;
  border-radius: 24px;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  background: var(--green);
  color: var(--white);
  box-shadow: 4px 4px 12px rgba(59, 185, 78, 0.3);
}

/* Bottom Buttons Row for Disclaimer and Add Your Company */
.bottom-buttons-row {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 16px;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 120px; /* Same height as previous Disclaimer button */
  z-index: 1;
}

.bottom-btn {
  background: var(--transparent);
  color: var(--white);
  font-size: 12px;
  padding: 6px 12px;
  border-radius: 24px;
  text-decoration: none;
  font-weight: bold;
  border: solid 1px var(--white);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  transition: background 0.3s ease;
}

.bottom-btn:hover {
  background: var(--white);
  color: var(--red);
}

.footer {
  position: absolute;
  width: 100%;
  padding: 16px;
  bottom: 40px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.buy-coffee {
  font-size: 14px;
  font-weight: bold;
  text-decoration: underline;
  color: var(--white);
}
</style>
